// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4878":"9bd11d0a","6256":"5b1732d8","6407":"2ebd0a16"}[chunkId] + ".chunk.css";
};